export type Bilingual = {
  en: string
  fr: string
}

export type ShiftIconId = 'sparkles' | 'identity' | 'shield'

export type HorizonShift = {
  num: string
  icon: ShiftIconId
  label: Bilingual
  stat: Bilingual
  claim: Bilingual
  source: Bilingual
  sourceUrl: string
  takeaway: Bilingual
  pills: Bilingual[]
}

export const horizonIntro = {
  eyebrow: {
    en: 'By 2028',
    fr: 'À l’horizon 2028',
  },
  headlineLead: {
    en: 'Three shifts are redefining',
    fr: 'Trois changements redéfinissent',
  },
  headlineAccent: {
    en: 'the digital experience.',
    fr: 'l’expérience numérique.',
  },
  intro: {
    en: 'Expectations are changing: people want outcomes, interactions are becoming contextual, and intelligence must be able to act with trust.',
    fr: 'Les attentes changent : les gens veulent des résultats, les interactions deviennent contextuelles et l’intelligence doit pouvoir agir en confiance.',
  },
}

export const horizonShifts: HorizonShift[] = [
  {
    num: '01',
    icon: 'sparkles',
    label: {
      en: 'From search to action',
      fr: 'De la recherche à l’action',
    },
    stat: {
      en: '1/3',
      fr: '1/3',
    },
    claim: {
      en: 'of interactions with generative AI services are expected to use action models or autonomous agents to complete tasks by 2028.',
      fr: 'des interactions avec les services d’IA générative devraient utiliser des modèles d’action ou des agents autonomes pour accomplir des tâches d’ici 2028.',
    },
    source: {
      en: 'Gartner, 2024',
      fr: 'Gartner, 2024',
    },
    sourceUrl:
      'https://www.gartner.com/en/newsroom/press-releases/2024-10-21-gartner-unveils-top-predictions-for-it-organizations-and-users-in-2025-and-beyond',
    takeaway: {
      en: 'I ask. The system acts.',
      fr: 'Je demande. Le système agit.',
    },
    pills: [
      { en: '“Sign me up.”', fr: '« Inscris-moi. »' },
      { en: '“Renew my permit.”', fr: '« Renouvelle mon permis. »' },
      { en: '“Book an appointment.”', fr: '« Prends rendez-vous. »' },
    ],
  },
  {
    num: '02',
    icon: 'identity',
    label: {
      en: 'From channels to context',
      fr: 'Des canaux au contexte',
    },
    stat: {
      en: '60%',
      fr: '60 %',
    },
    claim: {
      en: 'of brands are expected to use agentic AI to create seamless individual interactions by 2028.',
      fr: 'des marques devraient utiliser l’IA agentique pour créer des interactions individuelles fluides d’ici 2028.',
    },
    source: {
      en: 'Gartner, 2026',
      fr: 'Gartner, 2026',
    },
    sourceUrl:
      'https://www.gartner.com/en/newsroom/press-releases/2024-10-21-gartner-unveils-top-predictions-for-it-organizations-and-users-in-2025-and-beyond',
    takeaway: {
      en: 'One identity. Continuous context.',
      fr: 'Une identité. Un contexte continu.',
    },
    pills: [
      { en: 'Web', fr: 'Web' },
      { en: 'Mobile', fr: 'Mobile' },
      { en: 'Voice', fr: 'Voix' },
      { en: 'Services', fr: 'Services' },
      { en: 'Systems', fr: 'Systèmes' },
    ],
  },
  {
    num: '03',
    icon: 'shield',
    label: {
      en: 'From AI to trusted AI',
      fr: 'De l’IA à l’IA de confiance',
    },
    stat: {
      en: '50%',
      fr: '50 %',
    },
    claim: {
      en: 'of organizations are expected to adopt a zero-trust approach to data governance by 2028.',
      fr: 'des organisations devraient adopter une approche « zéro confiance » (zero trust) pour la gouvernance des données d’ici 2028.',
    },
    source: {
      en: 'Gartner, 2026',
      fr: 'Gartner, 2026',
    },
    sourceUrl:
      'https://www.gartner.com/en/newsroom/press-releases/2024-10-21-gartner-unveils-top-predictions-for-it-organizations-and-users-in-2025-and-beyond',
    takeaway: {
      en: 'Understand → Verify → Authorize → Act',
      fr: 'Comprendre → Vérifier → Autoriser → Agir',
    },
    pills: [
      { en: 'Transparency', fr: 'Transparence' },
      { en: 'Consent', fr: 'Consentement' },
      { en: 'Governance', fr: 'Gouvernance' },
      { en: 'Real impact', fr: 'Retombées concrètes' },
    ],
  },
]

export const horizonConclusion = {
  lead: {
    en: 'The future isn’t a better portal.',
    fr: 'L’avenir n’est pas un meilleur portail.',
  },
  accent: {
    en: 'It’s an organization that understands, orchestrates and acts.',
    fr: 'C’est une organisation qui comprend, orchestre et agit.',
  },
  brandSuffix: {
    en: 'connects it all.',
    fr: 'fait le lien.',
  },
  brandCaption: {
    en: 'Identity · Context · Intelligence · Systems · Action',
    fr: 'Identité · Contexte · Intelligence · Systèmes · Action',
  },
}
